import React from 'react'
import styled from 'styled-components'

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border: 1px solid transparent;
  margin-left: -10px;
  margin-bottom: 10px;
  color: #75AFB6;
  pointer-events: ${props => props.disabled ? 'none' : 'all'};
  &:hover {
    border: 1px solid ${props => props.disabled ? '#808080' : '#75AFB6'};
    border-radius: 3px;
  }
`
const BlueText = styled.a`
  cursor: pointer;
  color: ${props => props.disabled ? '#808080' : '#75AFB6'};
  padding: 2px 0;
  &:hover {
    text-decoration: none;
    color: unset;
  }
`


export default props => {
  const { children, onClick, disabled } = props
  return (
    <ButtonContainer disabled={disabled} onClick={onClick}>
      <BlueText disabled={disabled}>
        {children}
      </BlueText>
    </ButtonContainer>
  )
}